import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { MAX_ZOOM } from '../map.constants'
import { CoordinateMap } from '../map.types'
import IconSvg from '../../../atoms/icons/icon-svg'

interface MapProps {
  zoom: number
  center?: google.maps.LatLng
  bounds?: google.maps.LatLngBounds
}

interface SimpleMarkerProps extends CoordinateMap, MapProps {
  zoom: number
  onClick: () => void
  onDoubleClick: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  isSelected?: boolean
  text?: number | string
}

export const SimpleMarker = ({
  zoom,
  onClick,
  onDoubleClick,
  onMouseEnter,
  onMouseLeave,
  isSelected,
  text,
}: SimpleMarkerProps) => {
  return (
    <div
      className={clsx(s.containerMarker, {
        [s.containerMarkerSelected]: isSelected,
      })}
    >
      <div
        className={s.otaMarker}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <span className='flex min-w-0 items-center justify-center whitespace-nowrap'>
          {text}
        </span>
      </div>
      {zoom >= MAX_ZOOM && <div className={s.backgroundMarker}></div>}
      <div className={s.marker} onClick={onClick} onDoubleClick={onDoubleClick}>
        {text ? (
          text
        ) : (
          <IconSvg.House
            color={isSelected ? 'var(--clr-primary-400)' : 'var(--clr-white)'}
            height={15}
            width={15}
          />
        )}
      </div>
    </div>
  )
}

interface ClusterMarkerProps extends CoordinateMap, MapProps {
  text?: string
  zoom: number
  onClick: () => void
  isSelected?: boolean
}

export const ClusterMarker = ({
  text,
  zoom,
  onClick,
  isSelected,
}: ClusterMarkerProps) => {
  return (
    <div
      className={clsx(s.containerMarker, {
        [s.containerMarkerSelected]: isSelected,
      })}
      onClick={onClick}
    >
      <div className={s.otaClusterMarker}>{text}</div>
      <>
        {zoom >= MAX_ZOOM && <div className={s.backgroundMarker}></div>}
        <div className={s.marker}>
          {text ? text : <IconSvg.House color='white' height={15} width={15} />}
        </div>
      </>
    </div>
  )
}
